import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {DefaultHttpClient, HubConnection, LogLevel, HttpTransportType, HubConnectionBuilder} from '@microsoft/signalr';
import {Location} from '@angular/common';
import {HttpRequest} from '@microsoft/signalr/src/HttpClient';

export abstract class SignalRConnectionResolver  {
  reconnectIntervals: number[];

  protected constructor(private location: Location, private hub: string, private hasAutoReconnect: boolean = true) {
    this.reconnectIntervals = this.getReconnectIntervals();
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<HubConnection> {
    return new Promise<HubConnection>((resolve, reject) => {
      const hubConnection = new HubConnectionBuilder()
        .withUrl(this.location.normalize(`signalr/${this.hub}`), {
          logMessageContent: true,
          httpClient: new MesDefaultHttpClient(),
        })
        .configureLogging(LogLevel.Warning)
        .build();

      hubConnection.start()
        .then(value => {
          this.reconnectIntervals = this.getReconnectIntervals();
          resolve(hubConnection)
        })
        .catch(err => {
          reject(err);
          this.tryReconnect(route, state, err);
        });

      hubConnection.onclose(() => {
        if (this.hasAutoReconnect) {
          this.tryReconnect(route, state, null);
        }
      });

      return Promise.resolve(hubConnection);
    });
  }

  private tryReconnect(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, error: any) {
    const timeout = this.reconnectIntervals.shift()
    if (timeout !== undefined) {
      setTimeout(() => {
        this.resolve(route, state);
      }, timeout);
    } else {
      console.error(error?.toString());
    }
  }

  private getReconnectIntervals(): number[] {
    return [1000, 5000, 15000, 30000, 30000];
  }
}

class MesDefaultHttpClient extends DefaultHttpClient {
  constructor() {
    super(null);
  }

  send(request: HttpRequest) {
    request.headers = request.headers || {};
    request.headers['X-SignalR-Request'] = 'true';
    return super.send(request);
  }
}
